/**
 * Public browser-player origin for "Open web player" and pairing helpers.
 * Prefer VITE_PLAYER_PUBLIC_URL; in production, derive player.* from dashboard.*.
 */
export function getPlayerPublicUrl(
  env: {
    VITE_PLAYER_PUBLIC_URL?: string;
    DEV?: boolean;
  } = import.meta.env,
  locationHostname: string | null = typeof window !== 'undefined' ? window.location.hostname : null,
  locationProtocol: string = typeof window !== 'undefined' ? window.location.protocol : 'https:',
): string {
  const configured = env.VITE_PLAYER_PUBLIC_URL?.trim().replace(/\/$/, '');
  if (configured) return configured;

  if (env.DEV) return 'http://localhost:5174';

  if (locationHostname?.startsWith('dashboard.')) {
    const apex = locationHostname.slice('dashboard.'.length);
    return `${locationProtocol}//player.${apex}`.replace(/\/$/, '');
  }

  // Misconfigured production build — never silently send operators to localhost.
  throw new Error(
    'VITE_PLAYER_PUBLIC_URL is required for production dashboard builds (or host the app at dashboard.<domain>).',
  );
}
